import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector, getFormValues } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import ContentCardFooter from '../common/template/contentCardFooter';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Button from '../common/button/button';
import Form from '../common/form/form';
import LabelAndInput from '../common/form/labelAndInput';
import LabelAndCheckbox from '../common/form/labelAndCheckbox';
import LabelAndInputNumber from '../common/form/labelAndInputNumber';
import LabelAndInputDateTime from '../common/form/labelAndInputDateTime';
import Select from '../common/form/select';
import SelectAlteracao from '../common/form/selectAlteracao';
import LabelAndInputMask from '../common/form/labelAndInputMask';

import {
	setModoTela, initForm
} from './clienteActions';
import DateFormat from '../common/dateFormat/DateFormat';
import FormatUtils from '../common/formatUtils/FormatUtils';

class ClienteForm extends Component {

	state = {

	}

    componentDidMount() {
		window.scrollTo({
			top: 0,
			behavior: 'smooth'
		});
    }

    render() {
		
		let readOnly = this.props.excluir ? 'readOnly' : '';

		return (
			<ContentCard>

				{/* COBRANÇAS */}
				{!!this.props.formularioValues.listaCobrancas && this.props.formularioValues.listaCobrancas.length > 0 &&
					<div
						style={{
							padding: 12,
							borderBottom: '1px solid #eee',
							backgroundColor: '#fafafa'
						}}>
						<Row>
							{this.props.formularioValues.listaCobrancas.map((cobranca, index) => {

								let corStatus = '#999';

								if (cobranca.vencido || cobranca.protesto || cobranca.cartorio) {
									corStatus = '#e74c3c';
								} else {
									corStatus = '#f39c12';
								}

								return (
									<Grid
										key={index}
										cols='6 6 6 4'
										style={{ padding: 2, margin: 0 }}>

										<div
											style={{
												border: `1px solid ${corStatus}`,
												borderLeft: `5px solid ${corStatus}`,
												borderRadius: 8,
												padding: 12,
												backgroundColor: '#fff',
												boxShadow: '0 2px 6px rgba(0,0,0,0.05)',
												height: '100%'
											}}>

											<div
												style={{
													display: 'flex',
													justifyContent: 'space-between',
													alignItems: 'center',
													marginBottom: 4
												}}>

												<div
													style={{
														fontWeight: 'bold',
														fontSize: 11,
														color: corStatus
													}}>
													{cobranca.status}
												</div>

												<div
													style={{
														fontSize: 12,
														color: '#888'
													}}>
													<div
														style={{
															fontWeight: 'bold',
															fontSize: 11,
															color: corStatus
														}}>
														R$ {FormatUtils.formatarValorTela(cobranca.saldo, 2)}
													</div>
												</div>
											</div>

											<div
												style={{
													display: 'flex',
													justifyContent: 'space-between',
													alignItems: 'center'
												}}>
												<div>
													<div
														style={{
															fontSize: 10,
															color: '#999'
														}}>
														Emissão
													</div>

													<div
														style={{
															fontWeight: '600',
															fontSize: 10
														}}>
														{DateFormat.formatarDataSqlParaTela(cobranca.data_emissao)}
													</div>
												</div>

												<div>
													<div
														style={{
															fontSize: 10,
															color: '#999',
															textAlign: 'right'
														}}>
														Vencimento
													</div>

													<div
														style={{
															fontWeight: '600',
															fontSize: 10,
															textAlign: 'right'
														}}>
														{DateFormat.formatarDataSqlParaTela(cobranca.vencimento)}
													</div>
												</div>
											</div>
										</div>
									</Grid>
								)
							})}
						</Row>
					</div>}

				<Form event={this.props.handleSubmit}>

					{(!this.props.formularioValues.tipo_documento && !this.props.formularioValues.id_cliente) &&
					<ContentCardBody>
						<Row>
							<Field
								name='tipo_documento'
								options={[{ id: 'cpf', valor: 'CPF' }, { id: 'cnpj', valor: 'CNPJ' }]}
								component={Select}
								label='Pessoa Física ou Jurídica' placeholder='Informe'
								cols='1 1 1 1'
								minWidth={320} />
						</Row>
					</ContentCardBody>}

					{!!this.props.formularioValues.tipo_documento &&
					<ContentCardBody>
						<Row>
							<Field
								name='razao_social'
								component={LabelAndInput}
								label='Razão Social' placeholder='Informe'
								cols='12 12 6 6'
								readOnly={readOnly}
								uppercase />
							
							<Field
								name='nome_fantasia'
								component={LabelAndInput}
								label='Nome Fantasia' placeholder='Informe'
								cols='12 12 6 6'
								readOnly={readOnly}
								uppercase />

							{!!this.props.formularioValues.id_cliente &&
							<Field
								name='codigo'
								component={LabelAndInput}
								label='Código' placeholder='Informe'
								cols='1 1 1 1'
								minWidth={180}
								readOnly={'readOnly'} />}
						
							{(!this.props.formularioValues.tipo_documento || this.props.formularioValues.tipo_documento == 'cnpj') &&
							<Field
								name='cnpj'
								component={LabelAndInputMask}
								label='CNPJ' placeholder='Informe'
								cols='1 1 1 1'
								minWidth={220}
								readOnly={this.props.formularioValues.id_cliente ? 'readOnly' : null}
								mask='99.999.999/9999-99' />}
							
							{(this.props.formularioValues.tipo_documento == 'cpf') &&
							<Field
								name='cpf'
								component={LabelAndInputMask}
								label='CPF' placeholder='Informe'
								cols='1 1 1 1'
								minWidth={180}
								readOnly={this.props.formularioValues.id_cliente ? 'readOnly' : null}
								mask='999.999.999-99' />}

							{this.props.formularioValues.tipo_documento == 'cpf' &&
							<Field
								name='identidade'
								component={LabelAndInputNumber}
								label='RG' placeholder='Informe'
								cols='1 1 1 1'
								minWidth={180}
								readOnly={this.props.formularioValues.id_cliente ? 'readOnly' : null}
								casas={0}
								semSeparadorMilhar />}

							<Field
								name='inscricao'
								component={LabelAndInput}
								label='IE' placeholder='Informe'
								cols='1 1 1 1'
								minWidth={220}
								readOnly={readOnly} />
						</Row>
						<Row>							
							<Field
								name='endereco'
								component={LabelAndInput}
								label='Endereço' placeholder='Informe'
								cols='12 4 3 3'
								readOnly={readOnly}
								uppercase />
							
							<Field
								name='numero'
								component={LabelAndInput}
								label='Número' placeholder='Informe'
								cols='1 1 1 1'
								minWidth={180}
								readOnly={readOnly} />
							
							<Field
								name='complemento'
								component={LabelAndInput}
								label='Complemento' placeholder='Informe'
								cols='12 3 3 3'
								readOnly={readOnly}
								uppercase />
						
							<Field
								name='bairro'
								component={LabelAndInput}
								label='Bairro' placeholder='Informe'
								cols='12 4 3 3'
								readOnly={readOnly}
								uppercase />
							
							<Field
								name='cep'
								component={LabelAndInputMask}
								label='CEP' placeholder='Informe'
								cols='1 1 1 1'
								minWidth={180}
								readOnly={readOnly}
								mask='99999-999' />
								
							{!this.props.formularioValues.id_cliente &&
							<Field
								name='id_cidade'
								component={Select}
								options={this.props.listaCidade}
								label='Cidade' placeholder='Informe'
								cols='12 6 4 3' />}
								
							{!!this.props.formularioValues.id_cliente &&
							<Field
								name='nome_cidade'
								component={LabelAndInput}
								label='Cidade' placeholder='Informe'
								cols='12 6 4 3'
								readOnly={this.props.formularioValues.id_cliente ? 'readOnly' : null} />}

							{!!this.props.formularioValues.id_cliente &&
							<Field
								name='uf_cidade'
								component={LabelAndInput}
								label='UF' placeholder='Informe'
								cols='1 1 1 1'
								minWidth={80}
								readOnly={this.props.formularioValues.id_cliente ? 'readOnly' : null} />}
						</Row>
						<Row>
							<Field
								name='telefone'
								component={LabelAndInputMask}
								label='Telefone' placeholder='Informe'
								cols='1 1 1 1'
								minWidth={180}
								readOnly={readOnly}
								mask='(99) 99999-9999' />
							
							<Field
								name='celular'
								component={LabelAndInputMask}
								label='Celular' placeholder='Informe'
								cols='1 1 1 1'
								minWidth={180}
								readOnly={readOnly}
								mask='(99) 99999-9999' />

							<Field
								name='contato'
								component={LabelAndInput}
								label='Contato' placeholder='Informe'
								cols='12 1 1 1'
								minWidth={260}
								readOnly={readOnly}
								uppercase />
								
							<Field
								name='email'
								component={LabelAndInput}
								label='E-mail' placeholder='Informe'
								cols='12 1 1 1'
								minWidth={260}
								readOnly={readOnly} />

							<Field
								name='email_nfe'
								component={LabelAndInput}
								label='E-mail NF-e' placeholder='Informe'
								cols='12 1 1 1'
								minWidth={260}
								readOnly={readOnly} />

							<Field
								name='email_boleto'
								component={LabelAndInput}
								label='E-mail Boleto' placeholder='Informe'
								cols='12 1 1 1'
								minWidth={260}
								readOnly={readOnly} />
						</Row>
						<Row>
							<Field
								name='id_vendedor'
								component={LabelAndInputNumber}
								label='ID do Vendedor' placeholder='Informe'
								cols='12 1 1 1'
								minWidth={150}
								readOnly={readOnly}
								casas={0} />
						</Row>
					</ContentCardBody>}
					<ContentCardFooter>
						<Row alignCenter>
							<Grid cols='6 6 4 3'>
								{this.props.excluir ? (
									<Button
										text='Excluir'
										submit type={'danger'}
										icon={'fa fa-trash'} />
								) : (
								<Button
									text='Salvar'
									submit
									type={'success'}
									icon={'fa fa-check'} />
								)}
							</Grid>
							<Grid cols='6 6 4 3'>
								<Button
									text='Voltar'
									type={'warning'}
									icon={'fa fa-chevron-left'}
									event={() => this.props.setModoTela('lista')} />
							</Grid>
						</Row>
					</ContentCardFooter>
				</Form>
			</ContentCard>
		);
    }

}

ClienteForm = reduxForm({form: 'clienteForm', destroyOnUnmount: false})(ClienteForm);
const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	formularioValues: getFormValues('clienteForm')(state),
	registro: state.cliente.registro,
	listaCidade: state.cliente.listaCidade
});
const mapDispatchToProps = dispatch => bindActionCreators({
	setModoTela, initForm
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(ClienteForm);
